const intialState = {
    searchedUserList: [],
    delegateUserView: [],
    isLoadingViewDelegate: false,
    delegateDeleteRes: '',
    isLoadingDelegateDelete: false,
    delegateSwitchRes: {},
    isLoadingDelegateSwitchRes: false
}

export const DelegateUserReducer = (state = intialState, action) => {
    switch (action.type) {
        case 'GET_SEARCHED_USER_LIST':
            return {
                ...state,
                searchedUserList: action.payload.data
            }
        case 'SAVE_DELEGATE':
            return {
                ...state,
                savedDelegateRes: action.payload.data
            }
        case 'GET_DELEGATE_USER_VIEW':
            return {
                ...state,
                delegateUserView: action.payload.data
            }
        case 'GET_DELEGATE_DELETE':
            return {
                ...state,
                delegateDeleteRes: action.payload.data
            }
        case 'GET_DELEGATE_SWITCH':
            return {
                ...state,
                delegateSwitchRes: action.payload
            }
        case 'CLEAR_DELEGATE_DELETE':
                return {
                ...state,
                delegateDeleteRes: ''
            }
        case 'API_START':
            if (action.payload === 'GET_SEARCHED_USER_LIST') {
                return {
                    ...state,
                    isLoadingSearchedUserList: true
                }
            } if (action.payload === 'SAVE_DELEGATE') {
                return {
                    ...state,
                    isLoadingSavedDelegate: true
                }
            } if (action.payload === 'GET_DELEGATE_USER_VIEW') {
                return {
                    ...state,
                    isLoadingViewDelegate: true
                }
            } if (action.payload === 'GET_DELEGATE_DELETE') {
                return {
                    ...state,
                    isLoadingDelegateDelete: true
                }
            } if (action.payload === 'GET_DELEGATE_SWITCH') {
                return {
                    ...state,
                    isLoadingDelegateSwitchRes: true
                }
            } else {
                return state
            }

        case 'API_END':
            if (action.payload === 'GET_SEARCHED_USER_LIST') {
                return {
                    ...state,
                    isLoadingSearchedUserList: false
                }
            } if (action.payload === 'SAVE_DELEGATE') {
                return {
                    ...state,
                    isLoadingSavedDelegate: false
                }
            } if (action.payload === 'GET_DELEGATE_USER_VIEW') {
                return {
                    ...state,
                    isLoadingViewDelegate: false
                }
            } if (action.payload === 'GET_DELEGATE_DELETE') {
                return {
                    ...state,
                    isLoadingDelegateDelete: false
                }
            } if (action.payload === 'GET_DELEGATE_SWITCH') {
                return {
                    ...state,
                    isLoadingDelegateSwitchRes: false
                }
            } else {
                return state
            }

        default:
            return state
    }
}